import { twMerge } from "tailwind-merge";
import { ReactComponent as GridIcon } from "../../../assets/icons/grid.svg";
import { ReactComponent as ListIcon } from "../../../assets/icons/list.svg";

export function HCPViewSwitch({ view, setView }: { view: "list" | "grid", setView: (view: "list" | "grid") => void }) {
    return (
        <div className="flex items-center gap-3 bg-gray-100 rounded-full p-1">
            <button onClick={() => setView("list")} className={twMerge("w-[35px] h-[35px] flex items-center justify-center rounded-full bg-gray-200", view === "list" ? "bg-PraxisTerracotta" : "bg-transparent")}>
                <ListIcon className={twMerge(view === "list" ? "[&_path]:fill-white" : "[&_path]:fill-black")} />
            </button>
            <button onClick={() => setView("grid")} className={twMerge("w-[35px] h-[35px] flex items-center justify-center rounded-full bg-gray-200", view === "grid" ? "bg-PraxisTerracotta" : "bg-transparent")}>
                <GridIcon className={twMerge(view === "grid" ? "[&_path]:fill-white" : "[&_path]:fill-black")} />
            </button>
        </div>
    )
}